export const staticAssetsPath = 'https://samgnonprodt1weuinvd01.blob.core.windows.net/assets'

export const defaultErrorMsg = `Oops, it seems my virtual gears are having a cozy tea break ☕. Please try again after some time, and I'll be back with a freshly brewed answer for you!`

export const validFileInput = ['.pdf', '.docx', '.txt', '.pptx', '.xlsx', '.csv', '.html']

export const sizeInBytes = 1048576

export const messageSchema = {
  responseId: '',
  authorRole: 0, //0=bot, 1=user
  content: null,
  timestamp: new Date().getTime(),
  type: 'text', //text, file, component, loader, error
  avatarVisible: true,
  component: null,
  copyText: '',
  files: [],
  suggestions: [],
  sources: null, //source of content or data
  prompt: '' //content to show on i popup
}

export const documentScanMessage = {
  ...messageSchema,
  authorRole: 0,
  content: `I've received your attachments. How can I help?`,
  timestamp: new Date().getTime()
}

export const documentStartMessage = {
  ...messageSchema,
  authorRole: 0,
  type: 'documentStart',
  timestamp: new Date().getTime()
}

export const documentEndMessage = {
  ...messageSchema,
  authorRole: 0,
  type: 'documentEnd',
  timestamp: new Date().getTime()
}

export const welcomeMsgSchema = {
  header: 'Ask everyday questions',
  hideForSm: false,
  description: '',
  enableClick: true,
  noBorder: false,
  isLink: false
}

export const toolbarOptions = {
  options: [
    'inline',
    'blockType',
    'fontSize',
    'list',
    'textAlign',
    'colorPicker',
    'link',
    'emoji',
    'remove',
    'history'
  ]
}
